function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12,
  r: 12,
  fill: "#8FE558"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.0962,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.52131,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.8931,
  cy: 4.80328,
  r: 1.44,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.3182,
  cy: 4.22639,
  r: 0.576,
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.61719 9.11914H15.8572",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var Svg3Unfomfortable = function Svg3Unfomfortable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3Unfomfortable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3_Unfomfortable.72e547a7.svg";
export { ForwardRef as ReactComponent };